module.exports = __webpack_public_path__ + "static/media/Activationborder.7063843b.webp";